import { WIDGET_COLORS } from '../../constants/colors';
import { formatPoints, progressPercent } from '../../utils/formatSavingsPoints';
import type { SavingsPointsData } from '../../hooks/useGetSavingsPoints';
import { WidgetCardHeader } from '../widgetCardHeader';
import { WidgetDivider } from '../widgetDivider';
import { ProgressItem } from '../progressItem';
import { StatRow } from '../statRow';
import { WidgetNotice } from '../widgetNotice';

type Props = { data: SavingsPointsData };

export function FullyDivested({ data }: Props) {
  const earned = formatPoints(data.savings_points_earned);
  const pointsPercent = progressPercent(data.savings_points_earned, data.savings_points_required);

  return (
    <>
      <WidgetCardHeader variant="neutral" badgeText="Paused" />

      <WidgetDivider />

      <ProgressItem
        label="Community Points (preserved)"
        value={
          <span className="text-gray-500">
            <strong className="text-gray-700">{earned}</strong> - held for you
          </span>
        }
        barPercent={pointsPercent}
        segments={[{ flex: 1, color: WIDGET_COLORS.gray.bar }]}
      />

      <ProgressItem
        label="Estimated Eligibility"
        value={<span style={{ color: WIDGET_COLORS.gray.locked }}>- Paused</span>}
        barPercent={0}
        segments={[{ flex: 1, color: WIDGET_COLORS.gray.bar }]}
      />

      <StatRow
        bg={WIDGET_COLORS.gray.statBg}
        dividerColor={WIDGET_COLORS.gray.divider}
        left={{ value: `${earned} pts`, valueColor: WIDGET_COLORS.gray.muted, label: 'Points Preserved' }}
        right={{ value: '-', valueColor: WIDGET_COLORS.gray.locked, label: 'Eligibility Paused' }}
      />

      <WidgetNotice variant="neutral" icon="pause-circle">
        Your investment has been fully withdrawn. Your{' '}
        <strong>{earned} community points</strong> are preserved and will count towards your
        eligibility when you reinvest. Reinvest in GYS Home to resume your place in the home finance
        queue.
      </WidgetNotice>
    </>
  );
}
